import {
  BackgroundImageProps as MantineBackgroundImageProps,
  BackgroundImage as MantineBackgroundImage,
} from '@mantine/core';

export type BackgroundImageProps = MantineBackgroundImageProps;

export const BackgroundImage =
  MantineBackgroundImage as typeof MantineBackgroundImage;

BackgroundImage.displayName = 'BackgroundImage';
